import * as React from 'react';
import { SVGProps } from 'react';

const SvgPulse = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="M19.39 36.32h-.01c-.6 0-1.19-.22-1.64-.61l-.34-.28C7.17 26.61 2 19.29 2 13.69 2 8.09 5.9 4 11.71 4c2.78 0 5.06.87 6.76 2.58.33.33.64.69.92 1.07 1.34-1.84 3.67-3.64 7.67-3.64 5.88 0 9.69 3.8 9.69 9.69s-5.03 12.8-15.37 21.73l-.33.29c-.45.4-1.04.62-1.65.62l-.01-.02ZM11.71 5.5c-4.99 0-8.21 3.21-8.21 8.19 0 4.98 5 12.08 14.85 20.6l.36.29c.19.16.43.25.68.25.26 0 .49-.09.67-.25l.33-.29c9.86-8.5 14.85-15.43 14.85-20.6 0-5.17-3.13-8.19-8.18-8.19-4.03 0-6.04 2.12-7.02 3.9l-.66 1.21-.65-1.22c-.35-.65-.79-1.24-1.31-1.76-1.41-1.42-3.33-2.14-5.7-2.14l-.01.01Z"
    />
    <path
      fill="currentColor"
      d="m19.31 26.84-3.81-8.57-2.54 6.77H4.44v-1.5h7.48l3.46-9.23 4.19 9.43 3.75-5.63 4.65 4.65-1.06 1.06-3.36-3.36-4.24 6.38Z"
    />
    <path fill={props.fill} d="M37.35 21.59v5.39h-7.31l-5.37-5.39h12.69-.01Z" />
  </svg>
);

export default SvgPulse;
